import React from 'react';

import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import PreferenceCenterLink from './PreferenceCenterLink';

const PreferenceCenterDescription = () => {
    const localizedStrings = getLocalizedStrings();
    const descriptionText = localizedStrings[localizationKeys.PREFERENCE_CENTER_DESCRIPTION_TEXT];
    const formatedDescriptionText = localizedStrings.formatString(descriptionText, <PreferenceCenterLink />);
    const isNotLinkInserted = formatedDescriptionText === descriptionText; // if true - the text does not contain a parameter

    return (
        <div className='mb-6 text-16 leading-15'>
            {formatedDescriptionText}
            {/* this is to support markets with a legacy localization key value */}
            {isNotLinkInserted && <PreferenceCenterLink />}
        </div>
    );
};

export default PreferenceCenterDescription;
